import CopyIcon from '../../../../assets/icons/common/CopyIcon';
import useNoty from '../../../../hooks/useNoty';
import styles from './styles.module.scss';
import cn from 'classnames';

const CopyToClipboard = ({ text, className }) => {
  const noty = useNoty();
  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      noty.success({
        value: 'Copied to the clipboard',
      });
    } catch (err) {
      noty.success({
        value: 'A problem occurred when copying',
      });
    }
  };
  return (
    <button
      className={cn(styles.copyToClipboard, className)}
      onClick={handleClick}
    >
      <CopyIcon></CopyIcon>
    </button>
  );
};

export default CopyToClipboard;
